import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

export const Content = DropdownMenuPrimitive.Content;
export const DropdownItem = DropdownMenuPrimitive.Item;
export const DropdownMenu = DropdownMenuPrimitive.Root;
export const ItemIndicator = DropdownMenuPrimitive.ItemIndicator;
export const Label = DropdownMenuPrimitive.Label;
export const MenuGroup = DropdownMenuPrimitive.Group;
export const Portal = DropdownMenuPrimitive.Portal;
export const RadioGroup = DropdownMenuPrimitive.RadioGroup;
export const RadioItem = DropdownMenuPrimitive.RadioItem;
export const Separator = DropdownMenuPrimitive.Separator;
export const Trigger = DropdownMenuPrimitive.Trigger;
